const STAR_PATH =
  "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z";

interface StarRatingProps {
  score: number;
}

export function StarRating({ score }: StarRatingProps) {
  const stars = Math.round((score / 100) * 5 * 2) / 2;
  const full = Math.floor(stars);
  const half = stars - full >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);
  const fillColor = stars >= 4 ? "#facc15" : stars >= 2 ? "#f97316" : "#ef4444";
  const halfGradientId = `half-star-${Math.round(score)}`;

  return (
    <div className="flex gap-0.5">
      {Array.from({ length: full }).map((_, i) => (
        <svg key={`f${i}`} className="h-4 w-4" viewBox="0 0 20 20" fill={fillColor}>
          <path d={STAR_PATH} />
        </svg>
      ))}
      {half && (
        <svg className="h-4 w-4" viewBox="0 0 20 20">
          <defs>
            <linearGradient id={halfGradientId}>
              <stop offset="50%" stopColor={fillColor} />
              <stop offset="50%" stopColor="#e5e7eb" />
            </linearGradient>
          </defs>
          <path fill={`url(#${halfGradientId})`} d={STAR_PATH} />
        </svg>
      )}
      {Array.from({ length: empty }).map((_, i) => (
        <svg key={`e${i}`} className="h-4 w-4" viewBox="0 0 20 20" fill="#e5e7eb">
          <path d={STAR_PATH} />
        </svg>
      ))}
    </div>
  );
}
